import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Box, Typography, Button } from '@material-ui/core';
import withWidth from '@material-ui/core/withWidth';
import Layout from "../components/layout";
import revistaINTImage from '../assets/revistas/internacionalismo.png';
import revistaEDMImage from '../assets/revistas/EDM.png';
import intData from '../assets/revistas/internacionalismo.json';

const useStyles = makeStyles(theme => ({
    boxContenedor:{
        position:'relative',
        textAlign:"center",
        margin:"2rem",
    },
    pageControls:{
      marginTop:"1rem",
      display:"flex",
      justifyContent:"center",
    },
    boxCenterControls:{
        width:"10rem",
        position:"relative",
    },  
    gridNotaItem:{
      marginBottom: '2rem',
      [theme.breakpoints.down('xs')]: {
        marginBottom: '1rem',
      }
    },
    boxRevistaHeader: {
      backgroundColor:"#E5332A",
      marginTop:"2rem", 
      padding:"3rem 3.5rem", 
      display:"flex", 
      justifyContent: "space-between",
      [theme.breakpoints.down('sm')]: {
        padding:"1rem 1.5rem",
        marginTop:"1rem",
      },
    },
    boxRevistaListaLabel: {display:"flex",flexDirection:"column"},
    labelRevistaBoldBlack: {
      color:"black",
      fontSize:"4rem",
      fontFamily:"FuturaBold",
      lineHeight:"1.5rem",
      marginTop:"2.7rem",
      [theme.breakpoints.down('sm')]: {
        fontSize:"1.3rem",
        marginTop:"0.3rem",
      },
    },
    labelRevistaBoldWhite: {
      color:"white",
      fontSize:"4rem",
      fontFamily:"FuturaBold",
      lineHeight:"1.5rem",
      [theme.breakpoints.down('sm')]: {
        fontSize:"1.3rem",
      },
    },
    labelRevistaBoldWhiteLittle: {
      color:"white",
      fontFamily:"FuturaBold",
      [theme.breakpoints.down('sm')]: {
        fontSize:"0.5rem",
      },
    },
    labelRevistaWhiteLittle: {
      color:"white",
      [theme.breakpoints.down('sm')]: {
        fontSize:"0.5rem",
      },
    },
    goButton:{
      marginLeft: '1rem',
      border: '1px solid black',
      padding: 0,
      minWidth: '2rem',
    },
}));

function RevistaINTHeader() {
  const classes = useStyles();
  return(
    <Box className={classes.boxRevistaHeader}>
      <Box className={classes.boxRevistaListaLabel}>
        <span className={classes.labelRevistaBoldWhite}>Internacionalismo</span>
      </Box>
      <Box className={classes.boxRevistaListaLabel} style={{alignSelf:"center"}}>
        <span className={classes.labelRevistaBoldWhiteLittle}>Nº 1 al 6</span>
        <span style={{color:"white"}}>(1980-1983)</span>
      </Box>
    </Box>
  );
}

function Internacionalismo(props) {
  const classes = useStyles();

  return (
    <Layout>
      <RevistaINTHeader />
      <Box display="flex" justifyContent="center" mt="1.5rem">
        <a
          key="revista-edm"
          target="_blank"
          rel="noopener noreferrer"
          href="https://politicaobrera.com/revista/edm"
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            borderBottom="2px solid black"
          >
            <img
              src={revistaEDMImage}
              alt="Revista EDM"
              style={{ maxWidth: '10rem' }}
            />
            <Typography variant='h6'>Revisá también la revista EDM</Typography>
          </Box>
        </a>
      </Box>      
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
        <Box style={{ padding: '2rem' }}>
          <Box style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
            {intData.map(item => (
              <Box key={item.id} style={{ border: '1px solid #ccc', padding: '1rem', borderRadius: '6px', maxWidth: "400px" }}>
                <Box display="flex" alignItems="center">
                  <img
                    src={revistaINTImage}
                    alt={item.titulo}
                    style={{ width: 135, height: 180, objectFit: 'cover', marginRight: "2rem" }}
                  />
                  <Box display="flex" flexDirection="column" alignItems="flex-start">
                    <h3>{item.titulo}</h3>
                    <Box mb="20px">
                      <a href={item.url} target="_blank" rel="noopener noreferrer">
                        <Button variant='contained'>Ver</Button>
                      </a>
                    </Box>
                    <Box>
                      <a href={item.url} download>
                        <Button variant='contained'>Descargar</Button>
                      </a>
                    </Box>
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Layout>
  );
}

export default withWidth()(Internacionalismo);